/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Copy_ResultsInputs */

const bn_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফলাফল কপি করুন`)
};

const de_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse kopieren`)
};

const el_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγραφή αποτελεσμάτων`)
};

const en_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy results`)
};

const es_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar resultados`)
};

const fr_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les résultats`)
};

const hi_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम कॉपी करें`)
};

const hu_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eredmények másolása`)
};

const id_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin hasilnya`)
};

const it_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia i risultati`)
};

const ja_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果をコピーする`)
};

const ko_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결과 복사`)
};

const nl_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieer resultaten`)
};

const pl_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj wyniki`)
};

const pt_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar resultados`)
};

const ru_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать результаты`)
};

const sv_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera resultat`)
};

const tr_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuçları kopyala`)
};

const uk_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копіювати результати`)
};

const vi_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép kết quả`)
};

const zh_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制结果`)
};

const zh_hant_action_copy_results = /** @type {(inputs: Action_Copy_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製結果`)
};

/**
* | output |
* | --- |
* | "Copy results" |
*
* @param {Action_Copy_ResultsInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_copy_results = /** @type {((inputs?: Action_Copy_ResultsInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Copy_ResultsInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_copy_results(inputs)
	if (locale === "de") return de_action_copy_results(inputs)
	if (locale === "el") return el_action_copy_results(inputs)
	if (locale === "en") return en_action_copy_results(inputs)
	if (locale === "es") return es_action_copy_results(inputs)
	if (locale === "fr") return fr_action_copy_results(inputs)
	if (locale === "hi") return hi_action_copy_results(inputs)
	if (locale === "hu") return hu_action_copy_results(inputs)
	if (locale === "id") return id_action_copy_results(inputs)
	if (locale === "it") return it_action_copy_results(inputs)
	if (locale === "ja") return ja_action_copy_results(inputs)
	if (locale === "ko") return ko_action_copy_results(inputs)
	if (locale === "nl") return nl_action_copy_results(inputs)
	if (locale === "pl") return pl_action_copy_results(inputs)
	if (locale === "pt") return pt_action_copy_results(inputs)
	if (locale === "ru") return ru_action_copy_results(inputs)
	if (locale === "sv") return sv_action_copy_results(inputs)
	if (locale === "tr") return tr_action_copy_results(inputs)
	if (locale === "uk") return uk_action_copy_results(inputs)
	if (locale === "vi") return vi_action_copy_results(inputs)
	if (locale === "zh") return zh_action_copy_results(inputs)
	return zh_hant_action_copy_results(inputs)
});